// eslint-disable-next-line boundaries/no-unknown-files
import { createApi } from '@reduxjs/toolkit/query/react';
// eslint-disable-next-line boundaries/element-types
import reducerPath from "../../../../app/reducerPath";
// eslint-disable-next-line boundaries/element-types
import createHeadRequest from "../../../../shared/http/createHeadRequest";
// eslint-disable-next-line boundaries/element-types
import checkStatus from "../../../../shared/http/checkStatus";
// eslint-disable-next-line boundaries/element-types
import HttpMethods from "../../../../shared/api/HttpMethods";
// eslint-disable-next-line import/no-named-as-default
import platoonGroupsResourceFromDtoService from "../services/data/platoonGroupsResource-from-dto.service";
// eslint-disable-next-line boundaries/element-types
import config from "../../../../shared/api/config";
// eslint-disable-next-line boundaries/element-types
import platoonGroupsResourceToDtoService from "../services/data/platoonGroupsResource-to-dto.service";
// eslint-disable-next-line boundaries/element-types
import baseQueryWithReAuth from "../../../baseQueryWithReAuth/baseQueryWithReAuth";

// Описываем методы обращения к беку
export const platoonGroupsResourceApi = createApi({
  reducerPath: `${reducerPath.platoonGroupsResource}/api`,
  tagTypes: ['TAG'],
  baseQuery: (...arg) => baseQueryWithReAuth(...arg, `${config.platoonGroupsResourceUrl}/platoon-groups`),
  endpoints: (builder) => ({
    getPlatoonGroupsId: builder.query({
      query: ({
        params, id
      }) => ({
        ...createHeadRequest({
          url: `/${id}`, method: HttpMethods.GET
        }),
        params,
        validateStatus: checkStatus,
      }),
      providesTags: ['TAG'],
      transformResponse: platoonGroupsResourceFromDtoService
    }),
    getPlatoonGroups: builder.query({
      query: ({
        params
      }) => ({
        ...createHeadRequest({
          url: ``, method: HttpMethods.GET
        }),
        params,
        validateStatus: checkStatus,
      }),
      providesTags: ['TAG'],
      transformResponse: (dto, meta) => ({
        totalCount: Number(meta.response.headers.get('X-Total-Count')),
        platoonGroups: dto.map((e, i) => ({
          ...platoonGroupsResourceFromDtoService(e, meta).data, id: i
        }))
      })
    }),
    patchPlatoonGroups: builder.mutation({
      query: ({
        body, id
      }) => ({
        ...createHeadRequest({
          url: `/${id}`, method: HttpMethods.PATCH
        }),
        body: platoonGroupsResourceToDtoService(body),
        validateStatus: checkStatus,
      }),
      invalidatesTags: ['TAG'],
      transformResponse: platoonGroupsResourceFromDtoService
    }),
    postPlatoonGroups: builder.mutation({
      query: ({
        body
      }) => ({
        ...createHeadRequest({
          url: ``, method: HttpMethods.POST
        }),
        body: platoonGroupsResourceToDtoService(body),
        validateStatus: checkStatus,
      }),
      invalidatesTags: ['TAG'],
      transformResponse: platoonGroupsResourceFromDtoService
    }),
    deletePlatoonGroup: builder.mutation({
      query: ({
        id
      }) => ({
        ...createHeadRequest({
          url: `/${id}`, method: HttpMethods.DELETE
        }),
        validateStatus: checkStatus,
      }),
      invalidatesTags: ['TAG'],
    }),
  }),
});

export const {
  useLazyGetPlatoonGroupsIdQuery,
  useGetPlatoonGroupsIdQuery,
  usePatchPlatoonGroupsMutation,
  usePostPlatoonGroupsMutation,
  useLazyGetPlatoonGroupsQuery,
  useGetPlatoonGroupsQuery,
  useDeletePlatoonGroupMutation,
} = platoonGroupsResourceApi;
